import { useDispatch, useSelector } from "react-redux";
import {
  addStudentData,
  clearIndex,
  downloadTemplate,
  getCurrentData,
  getStaffAttendanceDetails,
  getStudentAttendance,
  getStudentAttendanceDetails,
  resetState,
  resetUrl,
  saveStudentAttendance,
  setStudentName,
  updateStudentAttendanceStaff,
  uploadStudentAttendance,
  resetStudentAtttendance,
  resetStaffAtttendance,
  getAttendancePercentage,
  clearStudentAttendancePercentage,
  getStudentAttendancePercentageYearWise,
  getStudentAttendancePercentageDateRangeDepartmentWise,
  setOffset,
  setPage,
  setPerPage,
} from "../store/attendance";

export default function useAttendance() {
  const dispatch = useDispatch();

  const studentAttendance = useSelector(
    (state) => state.attendance?.studentAttendance
  );
  const staffAttendance = useSelector(
    (state) => state.attendance?.staffAttendance
  );
  const studentAttendancePercentage = useSelector(
    (state) => state.attendance?.studentAttendancePercentage
  );
  const studentAttendancePercentageYearWise = useSelector(
    (state) => state.attendance?.studentAttendancePercentageYearWise
  );

  const studentAttendancePercentageDeptWise = useSelector(
    (state) =>
      state.attendance?.studentAttendancePercentageDateRangeDepartmentWise
  );
  const loading = useSelector((state) => state.attendance?.loading);

  const fileUrl = useSelector((state) => state.attendance?.fileUrl);

  const page = useSelector((state) => state.attendance?.page);
  const perPage = useSelector((state) => state.attendance?.perPage);
  const offset = useSelector((state) => state.attendance?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));
  const getStudentAttendanceAction = (params) =>
    dispatch(getStudentAttendance(params));

  const uploadStudentAttendanceAction = (params) => {
    dispatch(uploadStudentAttendance(params));
  };
  const downloadTemplateAction = (params) => {
    dispatch(downloadTemplate(params));
  };
  const getStudentAttendanceDetailsAction = (params) => {
    dispatch(getStudentAttendanceDetails(params));
  };
  const getStaffAttendanceDetailsAction = (params) => {
    dispatch(getStaffAttendanceDetails(params));
  };
  const getAttendancePercentageAction = (params) => {
    dispatch(getAttendancePercentage(params));
  };
  const getStudentAttendancePercentageDateRangeDepartmentWiseAction = (
    params
  ) => {
    dispatch(getStudentAttendancePercentageDateRangeDepartmentWise(params));
  };
  const getStudentAttendancePercentageYearWiseAction = (params) => {
    dispatch(getStudentAttendancePercentageYearWise(params));
  };

  const getCurrentDataAction = (params) => {
    dispatch(getCurrentData(params));
  };
  const updateStudentAttendanceStaffAction = (params) => {
    dispatch(updateStudentAttendanceStaff(params));
  };

  const clearIndexAction = () => {
    dispatch(clearIndex());
  };

  const saveStudentAttendanceAction = (params) => {
    dispatch(saveStudentAttendance(params));
  };
  const addStudentDataAction = (params) => {
    dispatch(addStudentData(params));
  };
  const setStudentNameAction = (params) => {
    dispatch(setStudentName(params));
  };

  const resetUrlAction = () => dispatch(resetUrl());
  const resetStateAction = () => dispatch(resetState());
  const resetStudentAtttendanceAction = () =>
    dispatch(resetStudentAtttendance());
  const resetStaffAtttendanceAction = () => dispatch(resetStaffAtttendance());
  const clearStudentAttendancePercentageAction = () =>
    dispatch(clearStudentAttendancePercentage());

  return {
    staffAttendance,
    studentAttendance,
    loading,
    studentAttendancePercentage,
    fileUrl,
    studentAttendancePercentageYearWise,
    studentAttendancePercentageDeptWise,
    
    page,
    perPage,
    offset,

    // actions
    setOffsetAction,
    setPerPageAction,
    setPageAction,

    getStudentAttendanceAction,
    uploadStudentAttendanceAction,
    downloadTemplateAction,
    resetUrlAction,
    resetStateAction,
    getStudentAttendanceDetailsAction,
    getStaffAttendanceDetailsAction,
    getAttendancePercentageAction,
    getCurrentDataAction,
    updateStudentAttendanceStaffAction,
    clearIndexAction,
    saveStudentAttendanceAction,
    addStudentDataAction,
    setStudentNameAction,
    resetStudentAtttendanceAction,
    resetStaffAtttendanceAction,
    clearStudentAttendancePercentageAction,
    getStudentAttendancePercentageDateRangeDepartmentWiseAction,
    getStudentAttendancePercentageYearWiseAction,
  };
}
